import { useEffect, useState } from "react";
import { Menu, X, Send } from "lucide-react";
import { Logo } from "@/components/landing/Logo";

const NAV_LINKS = [
  { id: "a-vaga", label: "A vaga" },
  { id: "responsabilidades", label: "Responsabilidades" },
  { id: "requisitos", label: "Requisitos" },
  { id: "como-funciona", label: "Como funciona" },
  { id: "candidatura", label: "Candidatura" },
];

const DesktopNav = () => (
  <nav className="hidden lg:flex items-center gap-8" aria-label="Principal">
    {NAV_LINKS.map((l) => (
      <a
        key={l.id}
        href={`#${l.id}`}
        data-testid={`job-nav-${l.id}`}
        className="text-sm font-semibold text-[#1F2937] hover:text-[#3532B3] transition-colors relative group"
      >
        {l.label}
        <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-gradient-to-r from-[#3532B3] to-[#12DDB5] group-hover:w-full transition-all duration-300" />
      </a>
    ))}
  </nav>
);

const MobileMenu = ({ onClose }) => (
  <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-[#E5EAF2]">
    <nav className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-2">
      {NAV_LINKS.map((l) => (
        <a
          key={l.id}
          href={`#${l.id}`}
          onClick={onClose}
          className="px-4 py-3 rounded-2xl text-[#1F2937] font-semibold hover:bg-[#F6F8FB]"
        >
          {l.label}
        </a>
      ))}
      <a
        href="#candidatura"
        onClick={onClose}
        className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-gradient-to-r from-[#3532B3] to-[#3787F5] text-white font-semibold"
      >
        <Send size={16} />
        Candidatar-se
      </a>
    </nav>
  </div>
);

export const JobHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="job-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-[#E5EAF2] shadow-[0_4px_24px_rgba(15,23,42,0.04)]"
          : "bg-white/60 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Logo />
        <DesktopNav />

        <div className="flex items-center gap-3">
          <a
            data-testid="job-header-apply-btn"
            href="#candidatura"
            className="hidden sm:inline-flex items-center gap-2 px-5 py-3 rounded-full bg-gradient-to-r from-[#3532B3] to-[#3787F5] text-white text-sm font-semibold shadow-[0_8px_20px_rgba(53,50,179,0.25)] hover:shadow-[0_10px_28px_rgba(53,50,179,0.35)] hover:-translate-y-0.5 transition-all duration-300"
          >
            <Send size={16} strokeWidth={2.2} />
            Candidatar-se
          </a>

          <button
            data-testid="job-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-[#E5EAF2] text-[#1F2937] hover:bg-[#F6F8FB]"
            aria-label="Abrir menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && <MobileMenu onClose={() => setOpen(false)} />}
    </header>
  );
};
